/* eslint-disable react/prop-types */
import React, { Component } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { Redirect, Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Loader from "components/Loader";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";

import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import AddAlert from "@material-ui/icons/AddAlert";

const classes = makeStyles(styles);

class AddCourseBudget extends Component {
  state = {
    productId: 0,
    budgets: [],
    budget: "",
    redirect: false,
    adding: false,
    aAlert: false,
    onAmount: 0,
    offAmount: 0
  };
  componentDidMount() {
    this.setState({
      productId: this.props.match.params.id
    });
    axios.get("https://admin.akclasses.in/api/budget_mode/index").then(resp => {
      //console.log(resp.data);
      this.setState({
        budgets: resp.data
      });
    });
  }
  variantSubmit = e => {
    e.preventDefault();
    let payLoad = {
      budget_mode_id: parseInt(this.state.budget),
      online_price: this.state.onAmount,
      offline_price: this.state.offAmount
    };
    if (this.state.budget === "") {
      this.setState({
        aAlert: true
      });
    } else {
      this.setState({ adding: true });
      axios
        .post(
          "https://admin.akclasses.in/api/budget/create/" +
            this.state.productId,
          payLoad
        )
        .then(() => {
          //console.log(resp.data);
          this.setState({
            redirect: true,
            adding: false
          });
        });
    }
  };
  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: "/admin/coursebudgets/" + this.state.productId
          }}
        />
      );
    } else {
      return (
        <div>
          <GridContainer>
            {this.state.notification ? (
              <div style={{ position: "relative", left: "600px" }}>
                <SnackbarContent
                  message={"Product Key Added!"}
                  icon={AddAlert}
                  color="success"
                />
              </div>
            ) : null}
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="danger">
                    <EditIcon />
                  </CardIcon>
                  <h4 style={{ color: "black" }}>Course Budget</h4>
                </CardHeader>
                <CardBody>
                  <form onSubmit={this.variantSubmit}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <FormControl
                          style={{ marginTop: "12px" }}
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            Budget Mode
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu
                            }}
                            classes={{
                              select: classes.select
                            }}
                            value={this.state.budget}
                            inputProps={{
                              required: true,
                              name: "budget",
                              id: "simple-select",
                              onChange: e => {
                                this.setState({
                                  aAlert: false,
                                  budget: e.target.value
                                });
                              }
                              // //console.log(e.target.value);
                            }}
                          >
                            {this.state.budgets.map((v, i) => (
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected
                                }}
                                key={i}
                                value={v.id}
                              >
                                {v.title}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        {this.state.aAlert ? (
                          <div>
                            <span style={{ color: "red" }}>*required</span>
                          </div>
                        ) : null}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Online Amount"
                          id="float"
                          inputProps={{
                            type: "number",
                            onChange: e =>
                              this.setState({ onAmount: e.target.value })
                          }}
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText="Offline Amount"
                          id="float"
                          inputProps={{
                            type: "number",
                            onChange: e =>
                              this.setState({ offAmount: e.target.value })
                          }}
                          formControlProps={{
                            fullWidth: true
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <Button className="" color="warning" type="submit">
                          {this.state.adding ? <Loader /> : "Add Course Budget"}
                        </Button>
                        <Link
                          to={{
                            pathname: "/admin/coursesmaster"
                          }}
                        >
                          <Button className="btn-round" color="danger">
                            Cancel
                          </Button>
                        </Link>
                      </GridItem>
                    </GridContainer>
                  </form>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}

export default AddCourseBudget;
